// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"G3-z","dimensionLabel":"H3-z","styleChooserControlWrapper":"I3-z","styleChooserControl":"J3-z","disabled":"K3-z","giftCard":"L3-z","styleChooserText":"M3-z"};